/**
 * 606 Meta5 AI Trading - Price Ticker Component
 */
import React from 'react';
import { motion } from 'framer-motion';

const PriceTicker = ({ symbol, bid, ask, spread, time }) => {
  const spreadPips = spread ? spread.toFixed(1) : '0.0';
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="bg-white/[0.02] rounded-lg border border-white/10 p-3"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="font-bold text-white">{symbol}</span>
        <span className="text-xs text-[#71717A]">Spread: {spreadPips}</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="text-center p-2 bg-red-500/10 rounded">
          <div className="text-xs text-red-400 mb-1">Sell</div>
          <div className="text-sm font-mono text-white">{bid?.toFixed(5) || '--'}</div>
        </div>
        <div className="text-center p-2 bg-emerald-500/10 rounded">
          <div className="text-xs text-emerald-400 mb-1">Buy</div>
          <div className="text-sm font-mono text-white">{ask?.toFixed(5) || '--'}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default PriceTicker;
